// extracted by css-extract-rspack-plugin
export default {"link":"link-THjdgV","profileName":"profileName-TJC4y2","root":"root-EAnkWz","icon":"icon-jC41O2"};